<template>
  <IconField>
    <InputIcon class="pi pi-search" />
    <InputText 
      id="search" 
      v-model="searchValue" 
      type="search" 
      class="w-full md:w-25rem" 
      :placeholder="placeholder"
      @input="onInputChange" 
    />
  </IconField>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    placeholder: {
        type: String,
        required: false,
        default: 'Search...'
    },
    data: {
        type: Array,
        required: false,
        default: () => []
    },
    searchKey: {
        type: String,
        required: false,
        default: 'name'
    }
});

const emit = defineEmits(['search', 'filtered']);
const searchValue = ref('');

// Filter data based on search term
const filteredData = computed(() => {
    if (!props.data || !Array.isArray(props.data)) return [];
    if (!searchValue.value.trim()) return props.data;
    
    const searchTerm = searchValue.value.toLowerCase().trim();
    return props.data.filter(item => {
        const searchField = item[props.searchKey];
        if (!searchField) return false;
        return searchField.toLowerCase().includes(searchTerm);
    });
});

// Watch for changes in the search input
watch(searchValue, (newValue) => {
    // Emit search event with the search term
    emit('search', newValue);
    // Emit filtered data
    emit('filtered', filteredData.value);
});

// Trigger search when input changes
const onInputChange = () => {
    emit('search', searchValue.value);
    emit('filtered', filteredData.value);
};
</script>

<style scoped>
/* PrimeFlex and custom styles */
</style>